<!--
 * @Date: 2020-08-11 19:24:21
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-18 23:09:42
 * @FilePath: \pc-mall\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      maintenanceText: null,
      maintenance: false
    }
  }
}
</script>

<style lang="scss">
@import "./common/lightgray/content.min.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
  .picker-options {
    .el-input--prefix .el-input__inner {
      padding-right: 0 !important;
      padding-left: 36px !important;
    }
  }
  .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }
  .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }
}
</style>
